/**
 * Original motivational sentences written for this game. Plain ASCII punctuation only,
 * 40-90 characters, so they type cleanly on any keyboard layout.
 */
export const SENTENCES: string[] = [
  'Every expert was once a beginner who refused to give up.',
  'Small steps every day add up to big changes over time.',
  'You do not have to be perfect, you just have to keep going.',
  'The best time to start was yesterday. The next best time is now.',
  'Progress is progress, no matter how slow it feels today.',
  'Your future is built by what you choose to do right now.',
  'Mistakes are proof that you are trying something new.',
  'Believe in the version of you that has already done it.',
  'Hard work beats talent when talent does not work hard.',
  'Focus on the next step, not the whole staircase.',
  'Discipline is choosing what you want most over what you want now.',
  'You are stronger than the excuse that is holding you back.',
  'Great things never come from comfort zones.',
  'One good habit can quietly change your entire life.',
  'Do something today that your future self will thank you for.',
  'Courage is not the absence of fear but action in spite of it.',
  'Consistency will take you further than motivation ever could.',
  'A calm mind makes better decisions than a busy one.',
  'You cannot control the wind, but you can adjust your sails.',
  'Finish what you start and you will surprise yourself.',
  'Every sentence you type makes the next one a little easier.',
  'Rest when you need to, but never quit on yourself.',
  'Your only competition is who you were yesterday.',
  'Dream big, start small, and begin right now.',
  'The secret to getting ahead is simply getting started.',
  'Confidence comes from keeping the promises you make to yourself.',
  'Effort is the one thing that is always within your control.',
  'You learn more from one attempt than from a hundred plans.',
  'Slow down, breathe, and then take the next step with purpose.',
  'Be patient with yourself. Growth takes time and repetition.',
  'Nothing changes if nothing changes. Make one change today.',
  'A positive attitude turns obstacles into opportunities.',
  'Show up on the days you do not feel like it. Those days count double.',
  'You are capable of far more than you currently believe.',
  'Success is a series of small wins stacked on top of each other.',
  'Let your actions speak louder than your doubts.',
  'When you feel like stopping, remember why you started.',
  'Kindness to yourself is the fuel for everything else.',
  'Direction matters more than speed. Keep facing forward.',
  'What you practise, you become. Practise what you want to be.',
  'Turn the page. The next chapter is waiting for you to write it.',
  'Doubt kills more dreams than failure ever will.',
  'Make today so good that yesterday gets jealous.',
  'The climb is hard because the view at the top is worth it.',
  'Trust the process, even when the results are not visible yet.',
  'Your comfort zone is a nice place, but nothing grows there.',
  'Ask for help when you need it. That is strength, not weakness.',
  'The work you do when no one is watching is what defines you.',
  'Be the energy you want to see in the room.',
  'It always seems impossible until it is done.',
  'A goal without a plan is just a wish. Write the plan.',
  'Learn something new today, even if it is only one small thing.',
  'Do not count the days. Make the days count.',
  'Fall seven times, stand up eight, and keep walking.',
  'Your mind is a garden. Plant thoughts you want to grow.',
  'Happiness is found in doing, not merely in possessing.',
  'Speak to yourself the way you would speak to a good friend.',
  'The pain of discipline is far lighter than the pain of regret.',
  'Champions keep playing until they get it right.',
  'Simplify your day: one priority, done well, before anything else.',
  'You will never regret being kind or being early.',
  'Energy flows where attention goes. Choose your focus wisely.',
  'Stop waiting for permission. Give it to yourself.',
  'Every morning is a fresh chance to get it right.',
  'Do the hard thing first and the rest of the day will feel easy.',
  'Big results come from small actions repeated daily.',
  'Do not let a bad hour turn into a bad day.',
  'Celebrate tiny wins. They are the bricks of big victories.',
  'What feels hard now will feel easy after enough practice.',
  'Keep your eyes on the goal and your hands on the keys.',
  'Winners are not people who never fail, but people who never quit.',
  'The right time is a myth. There is only the time you have.',
  'Replace "I have to" with "I get to" and watch your mood shift.',
  'Preparation today is confidence tomorrow.',
  'Be curious, be brave, and be willing to look silly while learning.',
  'A river cuts through rock not by power but by persistence.',
  'Comparison is the thief of joy. Run your own race.',
  'Gratitude turns what you have into enough.',
  'You cannot pour from an empty cup. Take care of yourself first.',
  'Aim for progress, not perfection, and you will get both eventually.',
  'The harder you work for something, the greater it feels to achieve it.',
  'Doing your best is more important than being the best.',
  'A little progress each day adds up to big results.',
  'Be so busy improving yourself that you have no time for doubt.',
  'Your attitude determines your direction. Point it somewhere good.',
  'Do not stop when you are tired. Stop when you are done.',
  'Push yourself, because no one else is going to do it for you.',
  'Failure is not the opposite of success. It is part of success.',
  'Everything you have ever wanted is on the other side of fear.',
  'One day or day one. You decide.',
  'The road to success is always under construction.',
  'Leave every place a little better than you found it.',
  'It is never too late to be who you might have been.',
  'Work hard in silence and let your results make the noise.',
  'Difficult roads often lead to beautiful destinations.',
  'Start where you are. Use what you have. Do what you can.',
  'Motivation gets you started. Habit keeps you going.',
  'Be stubborn about your goals and flexible about your methods.',
  'You did not come this far to only come this far.',
  'Focus on being productive instead of being busy.',
  'Strive for excellence, not perfection.',
  'The expert in anything was once a nervous beginner.',
  'Your speed will come. Your accuracy has to be there first.',
  'Wake up with determination and go to bed with satisfaction.',
  'Doing nothing is the only way to guarantee no progress.',
  'Say yes to the things that scare you a little.',
  'Every accomplishment starts with the decision to try.',
  'Keep going. Everything you need will come to you at the right time.',
  'Positive thoughts create positive results.',
  'The only bad workout is the one that did not happen.',
  'Do not be afraid to give up the good to go for the great.',
  'Believe you can and you are already halfway there.',
  'When it rains, look for rainbows. When it is dark, look for stars.',
  'You are one decision away from a completely different life.',
  'Do what is right, not what is easy.',
  'Discipline is the bridge between goals and accomplishment.',
  'Act as if what you do makes a difference. It does.',
  'The future depends on what you do today.',
  'Be a voice, not an echo.',
  'A smooth sea never made a skilled sailor.',
  'Stay patient and trust your journey.',
  'Tough times never last, but tough people do.',
  'Whatever you are, be a good one.',
  'Set a goal that makes you want to jump out of bed in the morning.',
  'Good things come to those who work while they wait.',
  'You get in life what you have the courage to ask for.',
  'The way to get started is to quit talking and begin doing.',
  'Learn as if you will live forever, live as if you will die tomorrow.',
  'It does not matter how slowly you go as long as you do not stop.',
  'Happiness is not something ready made. It comes from your own actions.',
  'Quality is not an act, it is a habit.',
  'Be yourself; everyone else is already taken.',
  'Ambition is the path to success. Persistence is the vehicle you arrive in.',
  'No pressure, no diamonds.',
  'Impossible is just an opinion.',
  'The mind is everything. What you think, you become.',
  'Do not wish it were easier; wish you were better.',
  'Opportunities do not happen. You create them.',
  'Success usually comes to those who are too busy to be looking for it.',
  'Life is ten percent what happens to you and ninety percent how you react.',
  'You miss every shot you never take.',
  'What we fear doing most is usually what we most need to do.',
  'Make each day your masterpiece.',
  'Well done is better than well said.',
  'Perseverance is not a long race; it is many short races one after the other.',
  'Storms make trees take deeper roots.',
  'Keep your face always toward the sunshine and shadows will fall behind you.',
  'Never let the fear of striking out keep you from playing the game.',
];

/** Deterministic PRNG so the server can seed a race and clients can verify. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function pickSentences(count: number, seed = Date.now(), pool: string[] = SENTENCES): string[] {
  const rng = mulberry32(seed);
  const copy = [...pool];
  const out: string[] = [];
  while (out.length < count && copy.length) {
    const i = Math.floor(rng() * copy.length);
    out.push(copy.splice(i, 1)[0]!);
  }
  return out;
}
